import * as React from 'react';
var ScrollIntoHorizontalView = function (_a) {
    var children = _a.children, _b = _a.isSelected, isSelected = _b === void 0 ? false : _b, _c = _a.behavior, behavior = _c === void 0 ? 'auto' : _c, styles = _a.styles;
    var wrapperRef = React.useRef(null);
    React.useEffect(function () {
        var _a, _b;
        if (wrapperRef.current === null ||
            wrapperRef.current === undefined ||
            !isSelected) {
            return;
        }
        (_b = (_a = wrapperRef.current).scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(_a, {
            behavior: behavior,
            block: 'start',
            inline: 'nearest',
        });
    }, [wrapperRef, isSelected, behavior]);
    return (React.createElement("div", { ref: wrapperRef, style: styles }, children));
};
export default ScrollIntoHorizontalView;
